module.exports = __webpack_public_path__ + "static/media/bee.2f6a6765.png";